import React, { Component } from "react";
import {
    UserData,
    getResidualData,
    GetAllOrganizationsSingleCall,
    GetAllAgents,
    deleteResidualData,
    getLatestResidualData,
    getTempResidualData,
} from "../../api";
import Header from "../preapps/Header";
import Notifications, { notify } from "react-notify-toast";
import axios from "axios";
import Alert from "../alerts/Alert";
import ReactTooltip from "react-tooltip";
import InfoIcon from "@material-ui/icons/Info";
import ReactModal from "react-modal";
import "../../../sass/residuals.scss";
import ReactHtmlParser from "react-html-parser";
import InfiniteScroll from "react-infinite-scroll-component";
import { MonthsMapping } from "./partials/data/months-mapping.data";
import { YearsMapping } from "./partials/data/years-mapping.data";
import { withRouter } from "react-router-dom";

class Residuals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            selectedFile: null,
            residualTable: {
                data: [],
                total: 0,
            },
            page: 1,
            hasMore: true,
            showAlert: false,
            isUploading: false,
            isDeleting: false,
            deleteMessage: "",
            deleteSuccess: -1,
            deleteFail: -1,
            uploadError: [],
            message: "",
            Month: "",
            Year: "",
            Search: "",
            DeleteMonth: "",
            DeleteYear: "",
            UploadMonth: "",
            UploadYear: "",
            Processor: "",
            MonthsMapping: {
                ...MonthsMapping,
            },
            YearMapping: {
                ...YearsMapping,
            },
            ResidualDeleteModal: false,
            FileUploadModal: false,
            agents: [],
            partners: [],
            processors: [],
            selectedAgent: "",
            selectedOrganization: "",
            total: 0,
            total_amount: 0,
            partner_amount: 0,
            agent_amount: 0,
            house_amount: 0,
            team_lead_amount: 0,
            total_partner_override_amount: 0,
            temp_residual_count: 0,
        };
    }
    onFileChange = (event) => {
        this.setState(
            {
                selectedFile: event.target.files[0],
            },
            () => {},
        );
    };
    onFileUpload = () => {
        const formData = new FormData();
        if (this.state.selectedFile != null) {
            formData.append(
                "fileUpload",
                this.state.selectedFile,
                this.state.selectedFile.name,
            );
            formData.append("UploadMonth", this.state.UploadMonth);
            formData.append("UploadYear", this.state.UploadYear);
        }
        this.setState(
            {
                isUploading: true,

                uploadError: [],
            },
            () => {
                axios
                    .post("residuals/file/upload", formData, {
                        xsrfCookieName: "STRATUS-XSRF-TOKEN",
                        xsrfHeaderName: "STRATUS-XSRF-TOKEN",
                    })
                    .then((response) => {
                        this.setState({
                            isUploading: false,
                            success: response.data.success,
                            fail: response.data.fail,
                            UploadMonth: "",
                            UploadYear: "",
                            uploadError: [],
                        });
                        document.getElementById("fileUpload").value = "";
                    })
                    .catch((error) => {
                        this.setState({
                            uploadError: error.response.data.errors,
                            isUploading: false,
                        });
                    });
            },
        );
    };
    onResidualDelete = () => {
        let data = {
            Month: this.state.DeleteMonth,
            Year: this.state.DeleteYear,
        };
        if (this.state.DeleteMonth && this.state.DeleteYear) {
            this.setState({
                isDeleting: true,
            });
            deleteResidualData(data).then((response) => {
                this.setState({
                    deleteSuccess: response.deleteSuccess,
                    deleteFail: response.deleteFail,
                });
            });
        } else {
            this.setState({
                deleteMessage: "Please Select Month and Year",
            });
        }
    };
    fileData = () => {
        if (this.state.selectedFile) {
        }
    };
    residualDataRefresh = (resetData = false) => {
        let data = {
            Search: this.state.Search,
            Month: this.state.Month,
            Year: this.state.Year,
            page: this.state.page,
            Agent: this.state.Agent,
            Partner: this.state.Partner,
            Processor: this.state.Processor,
        };
        getResidualData(data).then((response) => {
            if (response.status) {
                this.setState({
                    total: response.total,
                    total_amount: response.total_amount,
                    agent_amount: response.total_agent_amount,
                    partner_amount: response.total_partner_amount,
                    house_amount: response.total_house_amount,
                    team_lead_amount: response.total_team_lead_amount,
                    total_partner_override_amount:
                        response.total_partner_override_amount,
                });
                if (resetData || this.state.residualTable.data.length == 0) {
                    this.setState({
                        residualTable: response.data,
                    });
                } else if (this.state.residualTable.data.length > 0) {
                    this.setState({
                        residualTable: {
                            ...this.state.residualTable,
                            data: [
                                ...this.state.residualTable.data,
                                ...response.data.data,
                            ],
                        },
                    });
                }
            }
        });
    };
    FullMonth = (index) => {
        var month = new Array();
        month[0] = "January";
        month[1] = "February";
        month[2] = "March";
        month[3] = "April";
        month[4] = "May";
        month[5] = "June";
        month[6] = "July";
        month[7] = "August";
        month[8] = "September";
        month[9] = "October";
        month[10] = "November";
        month[11] = "December";
        return month[index];
    };
    componentDidMount() {
        let CurrentDate = new Date();
        let CurrentMonth = CurrentDate.getMonth();
        let CurrentMonthName = this.FullMonth(CurrentMonth);
        let CurrentYear = CurrentDate.getFullYear();
        this.setState({
            UploadMonth: CurrentMonthName,
            UploadYear: CurrentYear,
        });
        UserData().then((response) => {
            this.setState({
                user: response,
            });
        });

        getTempResidualData({ count: true }).then((res) =>
            this.setState({ temp_residual_count: res.count }),
        );

        getLatestResidualData().then((response) => {
            if (response.Year && response.Month) {
                this.setState(
                    {
                        Month: this.FullMonth(response.Month - 1),
                        Year: response.Year,
                    },
                    () => {
                        this.residualDataRefresh();
                    },
                );
            }
        });
        GetAllOrganizationsSingleCall().then((response) => {
            if (response.success) {
                this.setState({
                    partners: response.organization,
                    processors: response.processor,
                });
            }
        });

        GetAllAgents().then((response) => {
            if (response.status) {
                let AgentUsers = [];
                response.users.map((key, value) => {
                    if (key.f) {
                        AgentUsers.push(key);
                    }
                });
                this.setState({
                    agents: AgentUsers,
                });
            }
        });
    }
    onHandleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };
    onHandleFilter = (event) => {
        this.setState(
            {
                [event.target.name]: event.target.value,
            },
            () => {
                this.residualDataRefresh(true);
            },
        );
    };
    fetchMoreData = () => {
        this.setState(
            {
                page: this.state.page + 1,
            },
            function () {
                this.residualDataRefresh();
            },
        );
    };
    renderTable = () => {
        const { residualTable, MonthsMapping } = this.state;
        const hasMore = residualTable.total > residualTable.data.length;
        return (
            <div>
                <div>
                    <table class="table table-striped table-responsive">
                        <tbody>
                            <tr>
                                <td>Total</td>
                                <td>Total Amount</td>
                                <td>Partner Amount</td>
                                <td>Partner Override Amount</td>
                                <td>Agent Amount</td>
                                <td>Team Lead Amount</td>
                                <td>House Amount</td>
                            </tr>
                            <tr>
                                <td>{this.state.total}</td>
                                <td>{this.state.total_amount}</td>
                                <td>{this.state.partner_amount}</td>
                                <td>
                                    {this.state.total_partner_override_amount}
                                </td>
                                <td>{this.state.agent_amount}</td>
                                <td>{this.state.team_lead_amount}</td>
                                <td>{this.state.house_amount}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <InfiniteScroll
                    dataLength={residualTable.data.length}
                    next={this.fetchMoreData}
                    hasMore={hasMore}
                    loader={<h4>Loading...</h4>}
                    endMessage={
                        <p style={{ textAlign: "center" }}>
                            <b>Yay! You have seen it all</b>
                        </p>
                    }
                    height={window.innerHeight - 240}
                >
                    <div class="tableFixHead">
                        <table class="table table-striped table-responsive">
                            <thead>
                                <tr>
                                    <th scope="col" className="text-center">
                                        ID
                                    </th>
                                    <th scope="col" className="text-center">
                                        MID
                                    </th>
                                    <th scope="col" className="text-center">
                                        Month
                                    </th>
                                    <th scope="col" className="text-center">
                                        Year
                                    </th>
                                    <th scope="col" className="text-center">
                                        DBA
                                    </th>
                                    <th scope="col" className="text-center">
                                        Agent
                                    </th>
                                    <th scope="col" className="text-center">
                                        Partner
                                    </th>
                                    <th scope="col" className="text-center">
                                        Processor
                                    </th>
                                    <th scope="col" className="text-center">
                                        Volume
                                    </th>
                                    <th scope="col" className="text-center">
                                        Transaction
                                    </th>
                                    <th scope="col" className="text-center">
                                        Income
                                    </th>
                                    <th scope="col" className="text-center">
                                        Expense
                                    </th>
                                    <th scope="col" className="text-center">
                                        Net
                                    </th>
                                    <th scope="col" className="text-center">
                                        Approved Date
                                    </th>
                                    <th scope="col" className="text-center">
                                        Calculation
                                    </th>
                                    <th scope="col" className="text-center">
                                        Total Amount
                                    </th>
                                    <th scope="col" className="text-center">
                                        Partner Amount
                                    </th>
                                    <th scope="col" className="text-center">
                                        Partner Override Amount
                                    </th>
                                    <th scope="col" className="text-center">
                                        Agent Amount
                                    </th>
                                    <th scope="col" className="text-center">
                                        Team Lead Amount
                                    </th>
                                    <th scope="col" className="text-center">
                                        House Amount
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(residualTable.data).map(
                                    (item, key) => {
                                        return (
                                            <tr className="text-center">
                                                <td className="text-center">
                                                    {item[1].id}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].mid}
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        MonthsMapping[
                                                            item[1].month
                                                        ]
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    {item[1].year}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].dba}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].agent}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].partner}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].processor}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].volume}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].transaction}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].income}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].expense}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].net}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].approved_date}
                                                </td>
                                                <td className="text-center">
                                                    {ReactHtmlParser(
                                                        item[1].calculation,
                                                    )}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].total_amount}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].partner_amount}
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        item[1]
                                                            .partner_override_amount
                                                    }
                                                </td>

                                                <td className="text-center">
                                                    {item[1].agent_amount}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].team_lead_amount}
                                                </td>
                                                <td className="text-center">
                                                    {item[1].house_amount}
                                                </td>
                                            </tr>
                                        );
                                    },
                                )}
                            </tbody>
                        </table>
                    </div>
                </InfiniteScroll>
            </div>
        );
    };

    renderFilters = () => {
        const { MonthsMapping, YearMapping, Search, Month, Year } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <InfoIcon
                            fontSize="large"
                            data-tip="You can search Partner,Agent,MID,DBA,Processor using this single field. Also You can search on various fields.
                        The Fields are : total,agent,partner,house and you can use operators such as >,<,=,<=,>=
                        So you can search like total>=123 or agent<123"
                        />
                    </div>
                    <ReactTooltip />
                </div>
                <div className="row text-center">
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                        <input
                            type="textfield"
                            name="Search"
                            id="Search"
                            className="form-control"
                            onChange={this.onHandleFilter}
                            placeholder="Search"
                        ></input>
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                        <select
                            name="Month"
                            id="Month"
                            className="form-control"
                            onChange={this.onHandleFilter}
                            value={Month}
                        >
                            <option value="">Select Month</option>
                            {Object.entries(MonthsMapping).map((item, key) => {
                                return (
                                    <option value={item[1]}>{item[1]}</option>
                                );
                            })}
                        </select>
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                        <select
                            name="Year"
                            id="Year"
                            className="form-control"
                            onChange={this.onHandleFilter}
                            value={Year}
                        >
                            <option value="">Select Year</option>
                            {Object.entries(YearMapping).map((item, key) => {
                                return (
                                    <option value={item[1]}>{item[1]}</option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className="row text-center" style={{ marginTop: "10px" }}>
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                        <select
                            name="Agent"
                            id="Agent"
                            className="form-control"
                            onChange={this.onHandleFilter}
                        >
                            <option value="">Select Agent</option>
                            {this.state.agents.map((agent, index) => (
                                <option
                                    key={`option-agent-${index + 1}`}
                                    value={agent.zoho_user_id}
                                >
                                    {agent.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                        <select
                            name="Partner"
                            id="Partner"
                            className="form-control"
                            onChange={this.onHandleFilter}
                        >
                            <option value="">Select Partners</option>
                            {this.state.partners.map((partner, index) => (
                                <option
                                    key={`option-partner-${index + 1}`}
                                    value={partner.name}
                                >
                                    {partner.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                        <select
                            name="Processor"
                            id="Processor"
                            className="form-control"
                            onChange={this.onHandleFilter}
                        >
                            <option value="">Select Processor</option>
                            {this.state.processors.map((processor, index) => (
                                <option
                                    key={`option-partner-${index + 1}`}
                                    value={processor}
                                >
                                    {processor}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row text-center" style={{ marginTop: "10px" }}>
                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                        <input
                            type="button"
                            onClick={this.clearFilter}
                            value="Clear Filter"
                        ></input>
                    </div>
                </div>
            </div>
        );
    };
    deleteResidual = () => {
        this.setState({
            ResidualDeleteModal: true,
        });
    };
    uploadResidual = () => {
        this.setState({
            FileUploadModal: true,
        });
    };
    onFileClose = () => {
        this.setState({
            FileUploadModal: false,
            ResidualDeleteModal: false,
        });
        window.location.reload();
    };
    clearFilter = () => {
        window.location.reload();
    };
    exportExcel = () => {
        const fileDownload = require("js-file-download");
        let data = {
            Search: this.state.Search,
            Month: this.state.Month,
            Year: this.state.Year,
            export_type: "XLSX",
        };

        exportResidualData(data).then((response) => {
            fileDownload(response.data, "report.xlsx");
        });
    };
    renderModal = () => {
        const {
            isUploading,
            MonthsMapping,
            YearMapping,
            uploadError,
            success,
            deleteSuccess,
            deleteFail,
            fail,
            isDeleting,
            deleteMessage,
            UploadMonth,
            UploadYear,
        } = this.state;
        return (
            <div>
                <ReactModal
                    isOpen={this.state.ResidualDeleteModal}
                    className="residual-file-upload"
                >
                    <div className="row">&nbsp;</div>
                    {deleteMessage ? (
                        <div className="row">
                            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                            <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                {deleteMessage}
                            </div>
                            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        </div>
                    ) : null}

                    {deleteSuccess > -1 || deleteFail > -1 ? (
                        <div className="row">
                            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                            <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                {deleteSuccess} permanent and {deleteFail}{" "}
                                temporary records successfully deleted.
                            </div>
                            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        </div>
                    ) : null}

                    <div className="row">
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                            <select
                                name="DeleteMonth"
                                id="DeleteMonth"
                                className="form-control"
                                onChange={this.onHandleChange}
                            >
                                <option value="">Select One</option>
                                {Object.entries(MonthsMapping).map(
                                    (item, key) => {
                                        return (
                                            <option value={item[1]}>
                                                {item[1]}
                                            </option>
                                        );
                                    },
                                )}
                            </select>
                            {uploadError.UploadMonth !== undefined && (
                                <div>
                                    {uploadError.UploadMonth.map((error, i) => {
                                        return (
                                            <span className="error">
                                                {error}
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                    </div>
                    <div className="row">
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                            <select
                                name="DeleteYear"
                                id="DeleteYear"
                                className="form-control"
                                onChange={this.onHandleChange}
                            >
                                <option value="">Select One</option>
                                {Object.entries(YearMapping).map(
                                    (item, key) => {
                                        return (
                                            <option value={item[1]}>
                                                {item[1]}
                                            </option>
                                        );
                                    },
                                )}
                            </select>
                            {uploadError.UploadYear !== undefined && (
                                <div>
                                    {uploadError.UploadYear.map((error, i) => {
                                        return (
                                            <span className="error">
                                                {error}
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                    </div>
                    <div className="row">&nbsp;</div>
                    <div className="row">
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                            {deleteSuccess == -1 && deleteFail == -1 && (
                                <div>
                                    {!isDeleting && (
                                        <button onClick={this.onResidualDelete}>
                                            Delete
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                            <button onClick={this.onFileClose}>Close</button>
                        </div>
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                    </div>
                </ReactModal>
                <ReactModal
                    isOpen={this.state.FileUploadModal}
                    className="residual-file-upload"
                >
                    {(success || fail) && (
                        <div className="row">
                            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                            <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                {success} records successfully imported. {fail}{" "}
                                failed.
                            </div>
                            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        </div>
                    )}
                    <div className="row">
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                            <input
                                type="file"
                                id="fileUpload"
                                onChange={this.onFileChange}
                            />
                            {uploadError.fileUpload !== undefined && (
                                <div>
                                    {uploadError.fileUpload.map((error, i) => {
                                        return (
                                            <span className="error">
                                                {error}
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                    </div>
                    <div className="row">&nbsp;</div>
                    <div className="row">
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                            <select
                                name="UploadMonth"
                                id="UploadMonth"
                                className="form-control"
                                onChange={this.onHandleChange}
                                value={UploadMonth}
                            >
                                <option value="">Select One</option>
                                {Object.entries(MonthsMapping).map(
                                    (item, key) => {
                                        return (
                                            <option value={item[1]}>
                                                {item[1]}
                                            </option>
                                        );
                                    },
                                )}
                            </select>
                            {uploadError.UploadMonth !== undefined && (
                                <div>
                                    {uploadError.UploadMonth.map((error, i) => {
                                        return (
                                            <span className="error">
                                                {error}
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                    </div>
                    <div className="row">
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                            <select
                                name="UploadYear"
                                id="UploadYear"
                                className="form-control"
                                onChange={this.onHandleChange}
                                value={UploadYear}
                            >
                                <option value="">Select One</option>
                                {Object.entries(YearMapping).map(
                                    (item, key) => {
                                        return (
                                            <option value={item[1]}>
                                                {item[1]}
                                            </option>
                                        );
                                    },
                                )}
                            </select>
                            {uploadError.UploadYear !== undefined && (
                                <div>
                                    {uploadError.UploadYear.map((error, i) => {
                                        return (
                                            <span className="error">
                                                {error}
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                    </div>
                    <div className="row">&nbsp;</div>
                    <div className="row">
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                        {!(success || fail) && (
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                {!isUploading && (
                                    <button onClick={this.onFileUpload}>
                                        Upload
                                    </button>
                                )}
                            </div>
                        )}
                        {(success || fail || !isUploading) && (
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                <button onClick={this.onFileClose}>
                                    Close
                                </button>
                            </div>
                        )}

                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                    </div>
                </ReactModal>
            </div>
        );
    };

    exportPath = (exportType) => {
        let path = `/residuals/data/export?export_type=${exportType}`;
        path = path + (this.state.Search ? "&Search=" + this.state.Search : "");
        path = path + (this.state.Month ? "&Month=" + this.state.Month : "");
        path = path + (this.state.Year ? "&Year=" + this.state.Year : "");
        path =
            path + (this.state.Partner ? "&Partner=" + this.state.Partner : "");
        path = path + (this.state.Agent ? "&Agent=" + this.state.Agent : "");
        return path;
    };
    render() {
        const { user, showAlert, alertHeader, alertMessage, variant } =
            this.state;
        return (
            <div className="website-wrapper application-page residualPage">
                <div className="page-bottom-wrap">
                    <div id="page-content-wrapper">
                        <Notifications />
                        {showAlert && (
                            <Alert
                                showAlert={showAlert}
                                heading={alertHeader}
                                message={alertMessage}
                                variant={variant}
                                handleDismissible={() => {
                                    this.setState({ showAlert: false });
                                }}
                            />
                        )}
                        <div>
                            <div className="row">
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                                <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                    <input
                                        type="button"
                                        onClick={this.uploadResidual}
                                        value="Upload Residual"
                                    ></input>
                                    &nbsp;&nbsp;
                                    <input
                                        type="button"
                                        onClick={this.deleteResidual}
                                        value="Delete Residual"
                                    ></input>
                                </div>
                                <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                    <div className="row">
                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                                            <a href={this.exportPath("CSV")}>
                                                <buton className="btn btn-primary">
                                                    Export CSV File
                                                </buton>
                                            </a>
                                        </div>
                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                                            <a href={this.exportPath("XLSX")}>
                                                <buton className="btn btn-primary">
                                                    Export Excel File
                                                </buton>
                                            </a>
                                        </div>
                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                                            <button
                                                onClick={() =>
                                                    this.props.history.push(
                                                        "/residuals/unprocessed",
                                                    )
                                                }
                                            >
                                                Unprocessed (
                                                {this.state.temp_residual_count}
                                                )
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                            </div>
                            {this.renderModal()}
                            <div className="row">&nbsp;</div>
                            <div className="row">
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                                <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                    {this.renderFilters()}
                                </div>
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                            </div>
                            <div className="row">&nbsp;</div>
                            <div className="row">
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                                <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                    {this.renderTable()}
                                </div>
                                <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(Residuals);
